import { createFileRoute } from '@tanstack/react-router';
import { ScheduleDetailView } from '@/pages/document-payment-schedules/schedule-detail-view';
import { PROTECTED, DOCUMENT_PAYMENT_SCHEDULES } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${DOCUMENT_PAYMENT_SCHEDULES}`;

export const Route = createFileRoute(
  '/protected/_layout/document-payment-schedules/_layout/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: ScheduleDetailModal,
});

function ScheduleDetailModal() {
  const { id } = Route.useParams();

  return <ScheduleDetailView scheduleId={id} />;
}
